import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import './filestab.css';
import { FiMoreVertical, FiDownload, FiCheck } from "react-icons/fi";
import { useAuth } from '../../../firebase/AuthProvider';
import { SheredCaseFileRes } from '../../../interfaces/file/file';
import { GetSharedUserFilesAsync } from '../../../services/fileServices/FileService';
import tableeyeopenicon from '../../../assets/images/tableeyeopenicon.svg';
import PDF from '../../../assets/images/PDF.svg';
import XLSX from '../../../assets/images/XLSX.svg';
import DOCX from '../../../assets/images/DOCX.svg';
import SIGN from '../../../assets/images/SIGN.svg';


import Loader from '../loader/Loader';
import moment from 'moment';
import { PaginationDto } from '../../../interfaces/Employee/Employee';
import Pagination from '../../ui/Pagination/Pagination';

const Filestab: React.FC = () => {

    const { currentUser } = useAuth();
    const { userId: viewedUserId } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);
    const [sharedFiles, setSharedFiles] = useState<SheredCaseFileRes[]>([]);
    const [sharedFileCount, setSharedFileCount] = useState<number>(0);
    const [pagination, setPagination] = useState<PaginationDto>({ pageNumber: 1, pageSize: 10 });
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);

    const MoreVertical = FiMoreVertical as any;
    const Download = FiDownload as any;
    const Check = FiCheck as any;

    const getFileIcon = (name: string) => {
        if (name.endsWith(".pdf")) return PDF;
        if (name.endsWith(".xlsx")) return XLSX;
        if (name.endsWith(".docx")) return DOCX;
        return PDF; // fallback
    };

    const getFileIconBg = (name: string) => {
        if (name.endsWith(".pdf")) return "bg-red-100";
        if (name.endsWith(".xlsx")) return "bg-green-100";
        if (name.endsWith(".docx")) return "bg-blue-100";
        return "bg-gray-100";
    };


    useEffect(() => {
        let isMounted = true;

        if (!currentUser) return;

        currentUser.getIdToken().then((token) => {
            if (isMounted) {
                GetSharedUserFiles(token);
            }
        });

        return () => {
            isMounted = false;
        };
    }, [pagination]);

    const GetSharedUserFiles = async (token: string) => {
        setLoading(true);

        if (!token || !viewedUserId) {
            setLoading(false);
            return;
        }

        try {
            const res = await GetSharedUserFilesAsync(token, viewedUserId);
            if (res.success) {
                setSharedFiles(res.data.sharedFileDto);
                setSharedFileCount(res.data.count);
            } else {
                toast.error(res.message);
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (pageNum: number) => {
        setPagination((prev) => ({
            ...prev,
            pageNumber: pageNum
        }))
    }

    const resetPageSize = (pageNumber: number, pageSize: number) => {
        setPagination({
            pageNumber: pageNumber,
            pageSize: pageSize
        })
    }

    return (
        <>
            {loading && <Loader />}
            <div className='common_content_inner mby_t_24'>
                {/* <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>File Name</th>
                            <th>Uploaded By</th>
                            <th>Uploaded Date</th>
                            <th className='action_th'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sharedFiles.length === 0 ? (
                            <tr className="text-center">
                                <td colSpan={4} >
                                    <p className=" mt-5">No Data Found</p>
                                </td>
                            </tr>
                        ) : (
                            sharedFiles.map((file, index) => (
                                <tr key={index}
                                    className="border-t border-gray-200 dark:border-gray-700 text-sm hover:bg-gray-50 dark:hover:bg-gray-800"
                                    onClick={() => {
                                        navigate(`/view/user/file/${file.fileId}`);
                                    }}
                                >
                                    <td className="file-name">
                                        {file.fileName}
                                    </td>
                                    <td className="file-user-name">
                                        {file.uploadedByUserName}
                                    </td>
                                    <td className="file-date">
                                        {moment
                                            .utc(file.uploadedOn)
                                            .local()
                                            .format("DD/MM/YYYY")}
                                    </td>
                                    <td>
                                        <div className='action_btn'>
                                            <span><img src={tableeyeopenicon} alt="tableeyeopenicon" /></span>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table> */}

                <div className="space-y-3">
                    {sharedFiles.length === 0 ? (
                        <div className="text-center py-6 text-sm text-gray-500">
                            No data found!
                        </div>
                    ) : (
                        sharedFiles.map((file) => (
                            <div
                                key={file.fileId}
                                className="flex flex-wrap gap-2 items-center justify-between p-2.5 rounded-[10px] bg-white hover:bg-gray-50"
                                style={{ border: "1px solid #E5E7EB" }}
                            >
                                {/* LEFT */}
                                <div
                                    className="flex items-center gap-3 cursor-pointer"
                                    onClick={() => navigate(`/view/user/file/${file.fileId}`)}
                                >
                                    {/* FILE ICON */}
                                    <div
                                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${getFileIconBg(
                                            file.fileName
                                        )}`}
                                    >
                                        <img
                                            src={getFileIcon(file.fileName)}
                                            alt="file-icon"
                                            className="w-4 h-4"
                                        />
                                    </div>

                                    {/* FILE INFO */}
                                    <div>
                                        <p className="text-sm font-medium text-gray-900 mb-1">
                                            {file.fileName}
                                        </p>
                                        <p className="text-xs text-[#6A7282] mt-1.5 mb-0 flex gap-x-3">
                                            <span>Uploaded by {file.uploadedByUserName}</span> <span>•</span>
                                            <span>{moment.utc(file.uploadedOn).local().fromNow()}</span>
                                        </p>
                                    </div>
                                </div>

                                {/* RIGHT */}
                                <div
                                    className="flex items-center gap-3 relative"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {/* SIGNED */}
                                    <span className="px-4 py-1.5 text-xs border rounded-lg flex items-center gap-1">
                                        <img
                                            src={SIGN}
                                            alt="file-icon"
                                            className="w-3 h-3"
                                        />
                                        Signed
                                    </span>

                                    {/* DOWNLOAD */}
                                    <button className="px-4 py-1.5 text-xs border rounded-lg hover:bg-gray-100 flex items-center gap-1">
                                        Download
                                    </button>

                                    {/* THREE DOT MENU */}
                                    <button
                                        onClick={() =>
                                            setOpenMenuId(
                                                openMenuId === file.fileId ? null : file.fileId
                                            )
                                        }
                                        className="p-2 rounded-full hover:bg-gray-200"
                                    >
                                        <MoreVertical />{""}
                                    </button>

                                    {/* DROPDOWN */}
                                    {openMenuId === file.fileId && (
                                        <div className="absolute right-0 top-10 w-28 bg-white border rounded-lg shadow-lg z-50">
                                            <button
                                                onClick={() =>
                                                    navigate(`/view/user/file/${file.fileId}`)
                                                }
                                                className="w-full px-4 py-2 text-sm text-left hover:bg-gray-100"
                                            >
                                                View
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {(sharedFileCount && sharedFileCount > 0) ? (
                    <Pagination
                        currentPage={pagination.pageNumber}
                        totalPages={Math.ceil(sharedFileCount / pagination.pageSize)}
                        onPageChange={onPageChange}
                        pageSize={pagination.pageSize}
                        resetPageSize={resetPageSize}
                    />
                ) : <></>}
            </div>
        </>
    );
};

export default Filestab;